export const thunkTypes = {
  LIST_QUEUE: `reports/listQueue`,
  RESOLVE_REPORT: `reports/resolveReport`,
};
